// extracted by mini-css-extract-plugin
export default {"f":"_3f5b5e2089","main":"_9b3103a3dd","btn":"_8853be21fa","w":"d6b474eb52","h":"d07d07ccb4","lh25":"_3277af1cf7","wb":"fb622d3f0e","b":"e5cbea8827","bx":"_1d40d887ff"};